/* ============================================================================
   CSV export helpers + the seeded name pools the roster generator draws from.

   This file used to also hold a mock record-drill surface (per-metric column
   specs and a deterministic row generator). Drill-down records are now live —
   `POST all-metric/drill-down` (`GetMetricDrillDown`), whose dynamic columns the
   modal renders as-is — so the mock is gone.
   ========================================================================== */

export const FIRST_NAMES = ["James", "Mary", "Robert", "Patricia", "John", "Jennifer", "Michael", "Linda", "David", "Barbara", "William", "Susan", "Richard", "Jessica", "Joseph", "Sarah", "Thomas", "Karen", "Charles", "Nancy", "Daniel", "Lisa", "Matthew", "Betty", "Anthony", "Margaret", "Mark", "Sandra", "Donald", "Ashley"];
export const LAST_NAMES = ["Smith", "Johnson", "Williams", "Brown", "Jones", "Garcia", "Miller", "Davis", "Rodriguez", "Martinez", "Hernandez", "Lopez", "Gonzalez", "Wilson", "Anderson", "Thomas", "Taylor", "Moore", "Jackson", "Martin", "Lee", "Perez", "Thompson", "White", "Harris", "Sanchez", "Clark", "Ramirez", "Lewis", "Robinson"];

/** Quote a cell whenever leaving it bare could change how a reader parses the
 *  file. Beyond the mandatory cases (quote, comma, newline) that means ANY
 *  whitespace, which is not merely cosmetic: Excel's import wizard, Google
 *  Sheets and LibreOffice SNIFF the delimiter by picking the character that
 *  splits every line into the same number of fields. A compare export of
 *  "Referrals vs Non-Admits vs Conversion Rate" put exactly one space on every
 *  line — the header's "Conversion Rate" and each row's "Jul '25" — so space
 *  tied with comma and won, landing "Jul" and "'25" in separate columns and
 *  shifting every metric one column right. The same export for "Average Daily
 *  Census" survived only because its header happened to hold 8 spaces. Quoted
 *  fields cannot be split that way, so the comma always wins. */
export function csvEscape(v: unknown): string {
  const s = String(v ?? "");
  return /["\s,]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
}

/** Turn a matrix of cells into a CSV file and trigger a browser download.
 *
 *  CRLF line endings and a leading UTF-8 BOM are what Excel wants: the BOM gets
 *  it to open the file straight as a UTF-8 comma-separated sheet (no import
 *  wizard, no mangled "…" or "%"), and RFC 4180 rows keep every other reader
 *  happy. */
export function downloadCsv(filename: string, rows: unknown[][]): void {
  const csv = rows.map((r) => r.map(csvEscape).join(",")).join("\r\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}
